<script>
import Layout from "@/router/layouts/auth";
import { mapState, mapActions } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";
import Languages from "@/components/widgets/languages";
import Password from "@/components/widgets/input-password";

export default {
  locales: {
    pt: {
      'Username': 'Usuário',
      'Password': 'Senha',
      'Username is required.': 'O nome de usuário é obrigatório.',
      'Sign in': 'Entrar',
      'Forgot your password?': 'Esqueceu sua senha?',
      "Don't have an account?": 'Não possui uma conta?',
      'Sign up': 'Cadastre-se',
      'TECHNOLOGY BY': 'TECNOLOGIA POR',
      'You have successfully logged in.': 'Login realizado com sucesso.',
      'The username and/or password are incorrect.': 'O usuário e/ou senha estão incorretos.',
    },
    es: {
      'Username': 'Nombre de Usuario',
      'Password': 'Contraseña',
      'Username is required.': 'El nombre de usuario es obligatorio.',
      'Sign in': 'Iniciar sesión',
      'Forgot your password?': '¿Olvidaste tu contraseña?',
      "Don't have an account?": '¿No tienes una cuenta?',
      'Sign up': 'Regístrate',
      'TECHNOLOGY BY': 'TECNOLOGÍA POR',
      'You have successfully logged in.': 'Has iniciado sesión con éxito.',
      'The username and/or password are incorrect.': 'El usuario y/o la contraseña son incorrectos.',
    },
  },
  components: {
    Layout,
    Languages,
    Password,
  },
  data() {
    return {
      language: "en",

      username: "m2n",
      password: "m2n12345678",
      loading: false,
      submitted: false,

      user: {
        name: "",
        username: "",
        avatar: "",
      },
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
    }),
  },
  validations: {
    username: { required },
    password: { required, minLength: minLength(6) },
  },
  created() {
    this.logout();
  },
  methods: {
    ...mapActions("account", ["login", "logout"]),
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const { username, password } = this;
        if (username && password) {
          this.alert.type = "";
          this.alert.message = "";
          this.loading = true;
          this.$v.$reset();
          this.login({ username, password });
        }
      }
    },
    clearUser() {
      this.username = "";
      this.user.name = "";
      this.user.username = "";
      this.user.avatar = "";
    },
  },
  mounted() {
    if (this.$store.state.account.user) {
      this.username = this.$store.state.account.user.username;
      this.user.name = this.$store.state.account.user.name;
      this.user.username = this.$store.state.account.user.username;
      this.user.avatar = this.$store.state.account.user.avatar;
    }
  },
  watch: {
    "alert.type": function (alert) {
      if (alert == "alert-danger") {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div id="auth" class="d-flex">
      <div class="login-content">
        <div class="pt-5 pb-2 text-center">
          <router-link class="align-middle" tag="a" to="/">
            <img class="w-100" style="max-width: 250px" src="@/assets/images/logo.png" />
          </router-link>
        </div>
        <div class="py-5">
          <b-form @submit.prevent="handleSubmit">
            <div v-if="alert.message" :class="'alert ' + alert.type">
              {{ alert.message }}
            </div>
            <b-form-group :label="t('Username')" label-for="username">
              <b-form-input v-model="username" type="text" :class="{ 'is-invalid': submitted && $v.username.$error }"></b-form-input>
              <div v-if="submitted && !$v.username.required" class="invalid-feedback">
                {{ t('Username is required.') }}
              </div>
            </b-form-group>
            <b-form-group :label="t('Password')" label-for="password">
              <Password v-model="password" :v="$v.password"></Password>
            </b-form-group>
            <div class="mt-4">
              <b-button :disabled="loading == true" type="submit" variant="default" class="btn-lg btn-block">
                {{ t('Sign in') }}
                <b-spinner v-if="loading" small class="ml-2 align-middle" variant="secondary" role="status"></b-spinner>
              </b-button>
            </div>
            <div class="mt-4 text-center">
              <router-link tag="a" to="/password-forgot" class="text-muted">
                {{ t('Forgot your password?') }}
              </router-link>
            </div>
          </b-form>
          <div class="mt-2 text-center">
            <p class="text-dark">
              {{ t("Don't have an account?") }}
              <router-link tag="a" to="/register" class="font-weight-medium text-muted">{{ t('Sign up') }}</router-link>
            </p>
            <Languages type="dropup"></Languages>
            <p class="mt-5 font-size-12 text-uppercase text-muted">
              <a class="text-muted font-size-11" target="_blank" href="https://m2n.com.br/?utm_source=m2n.com.br&utm_medium=link&utm_campaign=logo">
                {{ t('TECHNOLOGY BY') }}<br />
                <img alt="M2N" style="width: 50px" src="@/assets/images/logo-m2n.svg" />
              </a>
            </p>
          </div>
        </div>
      </div>
      <div class="flex-fill login-image d-none d-lg-block"></div>
    </div>
  </Layout>
</template>